<div class="flex-fill d-flex flex-column card p-3">
    <div class="d-flex flex-fill flex-column">
        <dx-data-grid #dataGrid keyExpr="id" class="flex-fill d-flex flex-column" [dataSource]="customers" (onRowDblClick)="rowDoubleClick($event)">
            <dxi-column dataField="id" width="80"></dxi-column>
            <dxi-column dataField="type.name" caption="Type" width="100"></dxi-column>
            <dxi-column dataField="companyName" caption="Company Name" width="175" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="customerUnixKey" caption="Customer Code" width="175" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="contactName" caption="Contact Name" width="175" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="billAddress1" caption="Address 1" width="175"></dxi-column>
            <dxi-column dataField="billAddress2" caption="Address 2" width="125"></dxi-column>
            <dxi-column dataField="billCity" caption="City" width="125"></dxi-column>
            <dxi-column dataField="billState" caption="State" width="100"></dxi-column>
            <dxi-column dataField="billZip" caption="Zip" width="75"></dxi-column>
            <dxi-column dataField="phone" width="125"></dxi-column>
            <dxi-column dataField="email" width="175"></dxi-column>
            <dxi-column dataField="preferredCommunication" width="100"></dxi-column>
            <dxi-column dataField="hasEmail" width="100"></dxi-column>
            <dxi-column dataField="hasActiveProductPriceOverride" caption="Active Override" width="125"></dxi-column>
            <dxi-column dataField="openBalance" caption="Open Balance" width="125" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="billCountry" caption="Country" width="125"></dxi-column>
            <dxi-column></dxi-column>

            <div *dxTemplate="let cell of 'linkTemplate'">
                @if (cell.data) {
                    <a [routerLink]="[]" (click)="open(cell.data)">{{ cell.text }}</a>
                }
            </div>

            <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="customer-search-grid"></dxo-state-storing>
            <div *dxTemplate="let data of 'toolbarButtons'">
                @if (canEdit) {
                    <button class="btn btn-sm btn-success me-2" (click)="open()">Add</button>
                }
                <button
                    class="btn btn-sm btn-primary me-2"
                    (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Open
                </button>
                @if (canEdit) {
                    <button
                        class="btn btn-sm btn-danger me-4"
                        (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    >
                        Delete
                    </button>
                    <button
                        class="btn btn-sm btn-primary"
                        (click)="editType(dataGrid.instance.getSelectedRowsData())"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    >
                        Edit Type
                    </button>
                    <button
                        class="btn btn-sm btn-primary ms-3"
                        (click)="emailStatements(dataGrid.instance.getSelectedRowsData())"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    >
                        Email Statement
                    </button>
                    <button
                        class="btn btn-sm btn-secondary ms-3"
                        (click)="printStatement(dataGrid.instance.getSelectedRowsData())"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    >
                        Print Statement
                    </button>
                }
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                @if (customers) {
                    <span class="me-3">
                        <strong>
                            {{ dataGrid.instance.totalCount() + " items" }}
                            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
                        </strong>
                    </span>
                }
            </div>
        </dx-data-grid>
    </div>
</div>
